module.exports = __webpack_public_path__ + "img/doctor.9954cc73.png";